// Version : 0.0.1
// Author : VISHNU
//Last ADD : add update code not working changes changes for alignment unwanted code remove response handle changes for alignement input '
// MODFIED DATA : 06-08-2025
import { docodeHexResponse } from '../../../_common/common.utils';
import LoanIndexDisbursementActionTypes from './loan-index-disbursement.types';

/* eslint-disable import/no-anonymous-default-export */
const INITIAL_STATE = {
	getParticularLoanIndexDetailsResponse: null,
	deleteParticularLoanIndexDetailsResponse: null,
	getParticularLoanIndexDetailsArr: [],
	getFinanceAccountsListResponse: null,
	getFinanceAccountsListArr: [],
	getLoanScheduleListResponse: null,
	getLoanScheduleListArr: [],
	updateLoanIndexFunderResponse: null,
	updateLoanIndexMeettimeResponse: null,
	createLoanIndexDisbursementResponse: null,
	createTransactionDisbursementResponse: null,
	createTransactionAdditionalChargesResponse: null,
	updateLoanIndexPOLResponse: null,
	getNextTransactionSerialNoResponse: null,
	getNextTransactionSerialNoArr: [],
	getProductAccountDetailsResponse: null,
	getProductAccountDetailsArr: [],
	getVoucherCountBasedOnCompanyResponse: null,
	getVoucherCountBasedOnCompanyArr: [],
	getInterBranchContraResponse: null,
	getLoandisbursementPDFResponse: null,
	getInterBranchContraArr: [],
	getAllProductAdditionalAccountResponse: null,
	getAllProductAdditionalAccountArr: [],
	getAllRangeProductResponse: null,
	getAllRangeProductArr: [],
	createTopupLoanIndextResponse: null,
	getInstrumentListResponse: null,
	getInstrumentListArr: [],
	getInvestorDetailsResponse: null,
	getInvestorDetailsArr: [],
	hdfcPayoutTransactionResponse: null,
};

export default (state = INITIAL_STATE, action: { type: any; payload: any }) => {
	switch (action.type) {
		/*********** FETCH PARTICULAR LOAN INDEX START ************************ */
		case LoanIndexDisbursementActionTypes.FETCH_PARTICULAR_LOAN_INDEX_DETAILS_SUCCESS:
			return {
				...state,
				getParticularLoanIndexDetailsResponse: action.payload,
				getParticularLoanIndexDetailsArr: docodeHexResponse(
					action.payload,
					'FetchParticularLoanIndexDetails',
				),
			};

		case LoanIndexDisbursementActionTypes.FETCH_PARTICULAR_LOAN_INDEX_DETAILS_FAILURE:
			return { ...state, getParticularLoanIndexDetailsResponse: action.payload };

		case LoanIndexDisbursementActionTypes.FETCH_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_CHANGED:
			return { ...state, getParticularLoanIndexDetailsResponse: null };
		/*********** FETCH PARTICULAR LOAN INDEX END ************************ */

		/*********** DELETE PARTICULAR LOAN INDEX START ************************ */
		case LoanIndexDisbursementActionTypes.DELETE_PARTICULAR_LOAN_INDEX_DETAILS_SUCCESS:
			return {
				...state,
				deleteParticularLoanIndexDetailsResponse: action.payload,
			};

		case LoanIndexDisbursementActionTypes.DELETE_PARTICULAR_LOAN_INDEX_DETAILS_FAILURE:
			return { ...state, deleteParticularLoanIndexDetailsResponse: action.payload };

		case LoanIndexDisbursementActionTypes.DELETE_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteParticularLoanIndexDetailsResponse: null };
		/*********** DELETE PARTICULAR LOAN INDEX END ************************ */

		/*********** FETCH FINANCE ACCOUNT START ************************ */
		case LoanIndexDisbursementActionTypes.FETCH_FINANCE_ACCOUNTS_SUCCESS:
			return {
				...state,
				getFinanceAccountsListResponse: action.payload,
				getFinanceAccountsListArr: docodeHexResponse(
					action.payload,
					'FinanceAccountsBasedonTypeKey',
				),
			};

		case LoanIndexDisbursementActionTypes.FETCH_FINANCE_ACCOUNTS_FAILURE:
			return { ...state, getFinanceAccountsListResponse: action.payload };

		case LoanIndexDisbursementActionTypes.FETCH_FINANCE_ACCOUNTS_RESPONSE_CHANGED:
			return { ...state, getFinanceAccountsListResponse: null };
		/*********** FETCH FINANCE ACCOUNT END ************************ */

		/*********** FETCH LOAN SCHEDULE LIST START ************************ */
		case LoanIndexDisbursementActionTypes.FETCH_LOAN_SCHEDULE_LIST_SUCCESS:
			return {
				...state,
				getLoanScheduleListResponse: action.payload,
				getLoanScheduleListArr: docodeHexResponse(
					action.payload,
					'getLoanInfoBasedOnMembersBothclosedKey',
				),
			};

		case LoanIndexDisbursementActionTypes.FETCH_LOAN_SCHEDULE_LIST_FAILURE:
			return { ...state, getLoanScheduleListResponse: action.payload };

		case LoanIndexDisbursementActionTypes.FETCH_LOAN_SCHEDULE_LIST_RESPONSE_CHANGED:
			return { ...state, getLoanScheduleListResponse: null };
		/*********** FETCH LOAN SCHEDULE LIST END ************************ */

		/*********** UPDATE LOANINDEX FUNDER START ************************ */
		case LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_FUNDER_SUCCESS:
			return {
				...state,
				updateLoanIndexFunderResponse: action.payload,
			};

		case LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_FUNDER_FAILURE:
			return { ...state, updateLoanIndexFunderResponse: action.payload };

		case LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_FUNDER_RESPONSE_CHANGED:
			return { ...state, updateLoanIndexFunderResponse: null };
		/*********** UPDATE LOANINDEX FUNDER END ************************ */

		/*********** UPDATE LOANINDEX MEETTIME START ************************ */
		case LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_MEETTIME_SUCCESS:
			return {
				...state,
				updateLoanIndexMeettimeResponse: action.payload,
			};

		case LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_MEETTIME_FAILURE:
			return { ...state, updateLoanIndexMeettimeResponse: action.payload };

		case LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_MEETTIME_RESPONSE_CHANGED:
			return { ...state, updateLoanIndexMeettimeResponse: null };
		/*********** UPDATE LOANINDEX MEETTIME END ************************ */

		/*********** CREATE LOAN INDEX DISBURESEMENT START ************************ */
		case LoanIndexDisbursementActionTypes.CREATE_LOANINDEX_DISBURSEMENT_SUCCESS:
			return {
				...state,
				createLoanIndexDisbursementResponse: action.payload,
			};

		case LoanIndexDisbursementActionTypes.CREATE_LOANINDEX_DISBURSEMENT_FAILURE:
			return { ...state, createLoanIndexDisbursementResponse: action.payload };

		case LoanIndexDisbursementActionTypes.CREATE_LOANINDEX_DISBURSEMENT_RESPONSE_CHANGED:
			return { ...state, createLoanIndexDisbursementResponse: null };
		/*********** CREATE LOAN INDEX DISBURESEMENT END ************************ */

		/*********** CREATE TRANSACTION DISBURSMENT START ************************ */
		case LoanIndexDisbursementActionTypes.CREATE_TRANSACTION_DISBURSEMENT_SUCCESS:
			return {
				...state,
				createTransactionDisbursementResponse: action.payload,
			};

		case LoanIndexDisbursementActionTypes.CREATE_TRANSACTION_DISBURSEMENT_FAILURE:
			return { ...state, createTransactionDisbursementResponse: action.payload };

		case LoanIndexDisbursementActionTypes.CREATE_TRANSACTION_DISBURSEMENT_RESPONSE_CHANGED:
			return { ...state, createTransactionDisbursementResponse: null };
		/*********** CREATE TRANSACTION DISBURSMENT START ************************ */

		/*********** CREATE TRANSACTION ADDITIONAL CHARGES START ************************ */
		case LoanIndexDisbursementActionTypes.CREATE_TRANSACTION_ADDITIONAL_CHARGES_SUCCESS:
			return {
				...state,
				createTransactionAdditionalChargesResponse: action.payload,
			};

		case LoanIndexDisbursementActionTypes.CREATE_TRANSACTION_ADDITIONAL_CHARGES_FAILURE:
			return { ...state, createTransactionAdditionalChargesResponse: action.payload };

		case LoanIndexDisbursementActionTypes.CREATE_TRANSACTION_ADDITIONAL_CHARGES_RESPONSE_CHANGED:
			return { ...state, createTransactionAdditionalChargesResponse: null };
		/*********** CREATE TRANSACTION ADDITIONAL CHARGES END ************************ */

		/*********** UPDATE LOANINDEX PUROSE LOAN START ************************ */
		case LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_POL_SUCCESS:
			return {
				...state,
				updateLoanIndexPOLResponse: action.payload,
			};

		case LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_POL_FAILURE:
			return { ...state, updateLoanIndexPOLResponse: action.payload };

		case LoanIndexDisbursementActionTypes.UPDATE_LOANINDEX_POL_RESPONSE_CHANGED:
			return { ...state, updateLoanIndexPOLResponse: null };
		/*********** UPDATE LOANINDEX PUROSE LOAN END ************************ */

		/*********** FETCH NEXT TRANSACTION SERIAL NO START ************************ */
		case LoanIndexDisbursementActionTypes.FETCH_NEXT_TRANSACTION_SERIAL_NO_SUCCESS:
			return {
				...state,
				getNextTransactionSerialNoResponse: action.payload,
				getNextTransactionSerialNoArr: docodeHexResponse(
					action.payload,
					'nextTransactionSerialNumberKey',
				),
			};

		case LoanIndexDisbursementActionTypes.FETCH_NEXT_TRANSACTION_SERIAL_NO_FAILURE:
			return { ...state, getNextTransactionSerialNoResponse: action.payload };

		case LoanIndexDisbursementActionTypes.FETCH_NEXT_TRANSACTION_SERIAL_NO_RESPONSE_CHANGED:
			return { ...state, getNextTransactionSerialNoResponse: null };
		/*********** FETCH NEXT TRANSACTION SERIAL NO END ************************ */

		/*********** FETCH PRODUCT ACCOUNT DEATIL START ************************ */
		case LoanIndexDisbursementActionTypes.FETCH_PRODUCT_ACCOUNT_DETAILS_SUCCESS:
			return {
				...state,
				getProductAccountDetailsResponse: action.payload,
				getProductAccountDetailsArr: docodeHexResponse(
					action.payload,
					'productAccountDetailKey',
				),
			};

		case LoanIndexDisbursementActionTypes.FETCH_PRODUCT_ACCOUNT_DETAILS_FAILURE:
			return { ...state, getProductAccountDetailsResponse: action.payload };

		case LoanIndexDisbursementActionTypes.FETCH_PRODUCT_ACCOUNT_DETAILS_RESPONSE_CHANGED:
			return { ...state, getProductAccountDetailsResponse: null };
		/*********** FETCH PRODUCT ACCOUNT DEATIL END ************************ */

		/*********** FETCH VOUCHER BASED ON COMPANY START ************************ */
		case LoanIndexDisbursementActionTypes.FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_SUCCESS:
			return {
				...state,
				getVoucherCountBasedOnCompanyResponse: action.payload,
				getVoucherCountBasedOnCompanyArr: docodeHexResponse(
					action.payload,
					'GetCompanyVoucherCountBasedOnCompanyKey',
				),
			};

		case LoanIndexDisbursementActionTypes.FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_FAILURE:
			return { ...state, getVoucherCountBasedOnCompanyResponse: action.payload };

		case LoanIndexDisbursementActionTypes.FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_RESPONSE_CHANGED:
			return { ...state, getVoucherCountBasedOnCompanyResponse: null };
		/*********** FETCH VOUCHER BASED ON COMPANY END ************************ */

		/*********** FETCH INTER BRANCH CONTRA START ************************ */
		case LoanIndexDisbursementActionTypes.FETCH_INTER_BRANCH_CONTRA_SUCCESS:
			return {
				...state,
				getInterBranchContraResponse: action.payload,
				getInterBranchContraArr: docodeHexResponse(
					action.payload,
					'getInterBranchContraAccountKey',
				),
			};

		case LoanIndexDisbursementActionTypes.FETCH_INTER_BRANCH_CONTRA_FAILURE:
			return { ...state, getInterBranchContraResponse: action.payload };

		case LoanIndexDisbursementActionTypes.FETCH_INTER_BRANCH_CONTRA_RESPONSE_CHANGED:
			return { ...state, getInterBranchContraResponse: null };
		/*********** FETCH INTER BRANCH CONTRA END ************************ */

		/*********** FETCH ALL PRODUCT ADDITIONAL ACCOUNT START ************************ */
		case LoanIndexDisbursementActionTypes.FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_SUCCESS:
			return {
				...state,
				getAllProductAdditionalAccountResponse: action.payload,
				getAllProductAdditionalAccountArr: docodeHexResponse(
					action.payload,
					'getAllProductAdditionalAccountListKey',
				),
			};

		case LoanIndexDisbursementActionTypes.FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_FAILURE:
			return { ...state, getAllProductAdditionalAccountResponse: action.payload };

		case LoanIndexDisbursementActionTypes.FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_RESPONSE_CHANGED:
			return { ...state, getAllProductAdditionalAccountResponse: null };
		/*********** FETCH ALL PRODUCT ADDITIONAL ACCOUNT END ************************ */

		/*********** FETCH ALL RANGE PRODUCT START ************************ */
		case LoanIndexDisbursementActionTypes.FETCH_ALL_RANGE_PRODUCT_SUCCESS:
			return {
				...state,
				getAllRangeProductResponse: action.payload,
				getAllRangeProductArr: docodeHexResponse(
					action.payload,
					'getFilterRangeProductListKey',
				),
			};

		case LoanIndexDisbursementActionTypes.FETCH_ALL_RANGE_PRODUCT_FAILURE:
			return { ...state, getAllRangeProductResponse: action.payload };

		case LoanIndexDisbursementActionTypes.FETCH_ALL_RANGE_PRODUCT_RESPONSE_CHANGED:
			return { ...state, getAllRangeProductResponse: null };
		/*********** FETCH ALL RANGE PRODUCT START ************************ */

		/*********** CREATE TOPUP LOAN INDEX START ************************ */
		case LoanIndexDisbursementActionTypes.CREATE_TOPUP_LOAN_INDEX_SUCCESS:
			return {
				...state,
				createTopupLoanIndextResponse: action.payload,
			};

		case LoanIndexDisbursementActionTypes.CREATE_TOPUP_LOAN_INDEX_FAILURE:
			return { ...state, createTopupLoanIndextResponse: action.payload };

		case LoanIndexDisbursementActionTypes.CREATE_TOPUP_LOAN_INDEX_RESPONSE_CHANGED:
			return { ...state, createTopupLoanIndextResponse: null };
		/*********** CREATE TOPUP LOAN INDEX START ************************ */

		/*********** FETCH INSTRUMENT START ************************ */
		case LoanIndexDisbursementActionTypes.FETCH_INSTRUMENT_LIST_SUCCESS:
			return {
				...state,
				getInstrumentListResponse: action.payload,
				getInstrumentListArr: docodeHexResponse(action.payload, 'GetAllInstrumentListKey'),
			};

		case LoanIndexDisbursementActionTypes.FETCH_INSTRUMENT_LIST_FAILURE:
			return {
				...state,
				getInstrumentListResponse: action.payload,
				getInstrumentListArr: [],
			};

		case LoanIndexDisbursementActionTypes.FETCH_INSTRUMENT_LIST_RESPONSE_CHANGED:
			return { ...state, getInstrumentListResponse: null };

		/*********** FETCH INSTRUMENT END ************************ */

		/*********** GET INVESTOR DETAILS START ************************ */
		case LoanIndexDisbursementActionTypes.GET_INVESTOR_DETAILS_SUCCESS:
			return {
				...state,
				getInvestorDetailsResponse: action.payload,
				getInvestorDetailsArr: docodeHexResponse(
					action.payload,
					'AllInvestmentMadeListKey',
				),
			};
		case LoanIndexDisbursementActionTypes.GET_INVESTOR_DETAILS_FAILURE:
			return { ...state, getInvestorDetailsResponse: action.payload };

		case LoanIndexDisbursementActionTypes.GET_INVESTOR_DETAILS_RESPONSE_CHANGED:
			return { ...state, getInvestorDetailsResponse: null };
		/*********** GET INVESTOR DETAILS END ************************ */

		/*********** HDFC PAYOUT TRANSACTION START ************************ */
		case LoanIndexDisbursementActionTypes.HDFC_PAYOUT_TRANSACTION_SUCCESS:
			return {
				...state,
				hdfcPayoutTransactionResponse: action.payload,
			};

		case LoanIndexDisbursementActionTypes.HDFC_PAYOUT_TRANSACTION_FAILURE:
			return {
				...state,
				hdfcPayoutTransactionResponse: action.payload,
			};

		case LoanIndexDisbursementActionTypes.HDFC_PAYOUT_TRANSACTION_RESPONSE_CHANGED:
			return { ...state, hdfcPayoutTransactionResponse: null };

		/*********** HDFC PAYOUT TRANSACTION END ************************ */
		default:
			return state;
	}
};
